
import { NgIf, NgClass, NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { AdminService } from '../../../../services/admin.service';
import { UserService } from '../../../../services/user.service';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-oa-maintainance',
    imports: [NextPage, TableModule, NgIf, NgFor, CheckboxModule, DropdownModule, NgClass, ButtonModule, FormsModule, TabViewModule],
    templateUrl: './oa-maintainance.component.html',
    styleUrl: './oa-maintainance.component.scss'
})
export class OaMaintainanceComponent {
  oaResult: any = {}
  oaWholeData: any[] = [];
  filterUserIdoaData: any[] = [];
  filterPlantoaData: any[] = [];
  oaOptionsUser: any = [];
  oaOptionsPlant: any = [];
  selectedOAUser: any = '';
  selectedOAName: any = '';
  selectedOAEmail: any = '';
  selectedOAPlant: any = '';
  isLoading: boolean = false;
  isValid: boolean = false;
  requiredFlag: boolean = false;
  selectValidMaximo: boolean = false;
  validUserEntered: boolean = false;
  ShowAdded: boolean = false;
  maximoList: any = [];
  selectMaximos: any[] = [];
  facilityName = '';
  userIdEntered = '';
  useremail = '';
  userName = '';
  constructor(private adminService: AdminService, private userService: UserService,private commonService:CommonService,private messageService : NotificationService) {
  }
  ngOnInit() {
    this.isLoading = true;
    this.ShowAdded = false;
    this.facilityName = this.commonService.getCurrentFacilityId();
    this.getOmcData();
  }
  getOmcData() {
    this.adminService.getOmcData("OA").subscribe((response: any) => {
      this.oaResult = response;
      this.processData()
    });
  }
  processData() {
    this.oaOptionsPlant = [...new Set(this.oaResult.objPlantMaximoNameList)];
    this.oaOptionsPlant = this.oaOptionsPlant.map((item: any) => {
      return {
        label: item,
        value: item
      };
    });
    this.oaOptionsUser = this.oaResult.caiList;
    this.oaOptionsUser = this.oaOptionsUser.map((item: any) => {
      return {
        label: item,
        value: item,
        email: item,
        displayName: item
      };
    });
    this.oaWholeData = this.oaResult.omcRecordList;
    this.selectedOAUser = this.oaOptionsUser[0].value;
    this.oaWholeData.map((item: any) => {
      if(item.cai == this.selectedOAUser) {
        this.selectedOAEmail = item.email;
        this.selectedOAName = item.displayName;
      }
    });
    // this.userService.getMaximoByUser(this.selectedOAUser,'OA').subscribe((response: any) => {
    //   if(response){
    //   this.selectedOAEmail = response.email;
    //   this.selectedOAName = response.displayName;
    //   }
    // });
    this.selectedOAPlant = this.oaOptionsPlant[0].value;
    this.filterOmcData();
  }
  filterOmcData() {
    this.filterUserIdoaData = this.oaWholeData.filter((item: any) => item.cai === this.selectedOAUser);
    this.filterPlantoaData = this.oaWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedOAPlant);
    this.isLoading = false
  }
  filterChangePlant(event: any) {
    this.filterPlantoaData = this.oaWholeData.filter((item: any) => ('('+item.plantMaximo + ') ' + item.plantName) === this.selectedOAPlant);
  }
  filterChangeUser(event: any) {
    this.filterUserIdoaData = this.oaWholeData.filter((item: any) => item.cai === this.selectedOAUser);
    this.oaWholeData.map((item: any) => {
      if(item.cai == this.selectedOAUser) {
        this.selectedOAName = item.displayName;
      }
    });
  }
  DeleteOmc(record: any) {
    this.showSuccess = false;
    if (confirm(`Are you sure you want to delete a record?`)) {
    this.adminService.deleteOmcData(record.recordID).subscribe((response: any) => {
      this.oaWholeData = this.oaWholeData.filter((item: any) => item.recordID != record.recordID);
      this.filterUserIdoaData = this.filterUserIdoaData.filter((item: any) => item.recordID != record.recordID);
      this.filterPlantoaData = this.filterPlantoaData.filter((item: any) => item.recordID != record.recordID);
      this.messageService.showSuccess('OA record deleted successfully' );
      this.showSuccess = true;

    });
  }
  }
  showSuccess: boolean = false;

  tabClick(){
    this.showSuccess = false;
    this.ShowAdded = false;
  }

  verifyUserId() {
    this.requiredFlag = false;
    this.showSuccess = false;
    this.ShowAdded = false;
        this.validUserEntered = false;
    if (this.userIdEntered.length > 0) {
      this.maximoList = [];
      this.userService.getMaximoByUser(this.userIdEntered,'OA').subscribe({
        next: (response: any) => {
          this.useremail = response.email;
          this.userName = response.displayName;
          this.isValid = response.isValid;
          this.maximoList = response.availablePlants;
        },
        error: (error) => {
          this.validUserEntered = true;
          this.messageService.showError('Please enter a valid User ID');
          this.useremail = '';
          this.userName = '';
          this.selectMaximos = [];
          this.maximoList = [];
          this.isValid = false;
        }
      });
    }
    else {
      this.messageService.showError('Please enter a valid User ID' );
      this.requiredFlag = true;
    }
  }
  addNewOA() {
    this.selectValidMaximo = false;
    this.ShowAdded = false;
    if (this.selectMaximos.length == 0) {
      this.messageService.showError( 'Please select at least one plant' );
      this.selectValidMaximo = true;
      return;
    }
    let payload = {
      "cai": this.userIdEntered,
      "email": this.useremail,
      "displayName": this.userName,
      "plantsListToBeAdded": this.selectMaximos,
      "facilityId": this.facilityName,
      "type": "OA"
    }
    this.userService.addMaximoForUser(payload).subscribe({
      next: (response: any) => {
        this.messageService.showSuccess('OA record added successfully' );
        this.userIdEntered = '';
        this.useremail = '';
        this.userName = '';
        this.selectMaximos = [];
        this.maximoList = [];
        this.isValid = false;
        this.ShowAdded = true;
        this.getOmcData(); // Refresh the data after adding a new record
      },
      error: (error) => {
        console.error(error);
        this.messageService.showError('Error adding Inspector record');
      }
    });
  }
}
